import { render, staticRenderFns } from "./CorporateAreaList.vue?vue&type=template&id=31acccfe&"
import script from "./CorporateAreaList.vue?vue&type=script&lang=js&"
export * from "./CorporateAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports